import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { withFormsy } from "formsy-react"
import { useSelector } from "react-redux"
import { getEffectiveTimezone } from "reduxSlices/currentSettingsSlice"
import { formSubmissionCreatedOnInOrganizationTimeZone } from "reduxSlices/formSubmissionSlice"
import { questionShape } from "utils/propTypeShapes"
import { yearMonthDayDateWithTz } from "utils/dateHelpers"
import { CURRENT_DATE, getDateDifference } from "utils/dateDifferenceHelpers"

const FormsyDiv = withFormsy(({ name, value, className }) => (
  <div className={clsx("my-1 form-input py-2 px-3 flex items-center", className)} name={name} value={value}>
    { value }
    {/* Keeps the height if there is no value */}
    &nbsp;
  </div>
))

const fetchDate = (formAnswers, questionUuid, currentDate) => (
  questionUuid === CURRENT_DATE ? currentDate : formAnswers[questionUuid]
)

const DateDifferenceAnswerField = ({ question, formAnswers, className = "" }) => {
  const { uuid, attributes } = question
  const { startDateQuestionUuid, endDateQuestionUuid, unitOfMeasure } = attributes

  const effectiveTimezone = useSelector(getEffectiveTimezone)
  const submissionCreatedOn = useSelector(formSubmissionCreatedOnInOrganizationTimeZone)

  // A question measuring from or to the date the form was filled out keeps
  // measuring from that date.  An existing submission reports the date it was
  // created on, so editing it long afterward does not move the value; a
  // submission being filled out now has no such date yet.
  const currentDate = submissionCreatedOn ?? yearMonthDayDateWithTz(new Date(), effectiveTimezone)

  const startDate = fetchDate(formAnswers, startDateQuestionUuid, currentDate)
  const endDate = fetchDate(formAnswers, endDateQuestionUuid, currentDate)

  let result = null

  if (startDate && endDate) {
    result = getDateDifference(startDate, endDate, unitOfMeasure)
  }

  return (
    <FormsyDiv name={uuid} value={result} className={className} />
  )
}

DateDifferenceAnswerField.propTypes = {
  className: types.string,
  // eslint-disable-next-line react/forbid-prop-types
  formAnswers: types.object.isRequired,
  question: questionShape.isRequired,
}

export default DateDifferenceAnswerField
